// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1VuMF","buttons":"RemoveExpirationActionButtons_buttons__A5uxj"};